"use strict";

function resizeWindow() {}
function scrollDown() {}

$(document).ready(function () {

	//defaults form jobs
	$("input[name=time_for_work]").eq(0).attr("checked", "checked");
	$("input[name=Are_you_of_legal_age_to_serve_alcoholic_beverages_in_this_state]").eq(1).attr("checked", "checked");
	$("input[name='Are_you_eligible_to_receive_any_and_all_permits/licenses_required_by_law']").eq(0).attr("checked", "checked");
	$("input[name=college]").eq(0).attr("checked", "checked");
	$("input[name=military_experience]").eq(1).attr("checked", "checked");
	$("input[name=ever_worked]").eq(1).attr("checked", "checked");
	$("input[name=time_for_work]").eq(0).attr("checked", "checked");

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});
	resizeWindow();

	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
		var top = $(document).scrollTop();
		if (top > 0) {} else {}
	});

	// 	$(".benefits-home ul li").wrapInner("<span></span>");

	// Main Nav Dropdown
	$("#primary-nav li").hover(function () {

		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {

		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() * 2 }, 800, 'easeOutExpo');
	});

	// 	header menu in tablet
	$(".burger-tablet").click(function () {

		$(".content-primary-nav").fadeIn();
		document.querySelector('.burger-tablet').style.opacity = "0";
	});

	$(".close-tablet").click(function () {

		$(".content-primary-nav").fadeOut();
		document.querySelector('.burger-tablet').style.opacity = "1";
	});

	// 	lists 
	$(".content-site ul li").wrapInner("<span></span>");

	function calendarRange(date) {
		var d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
		var d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
		if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
			DATE_STYLE[1] = 'highlight-top';
		} else if (date > d1 && date < d2) {
			DATE_STYLE[1] = 'highlight';
		} else {
			DATE_STYLE[1] = '';
		}
		return DATE_STYLE;
	}

	//Event Tracking
	$('.book-now').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
	});

	//Check in and check out datepicker for booking engine
	$("#CheckIn").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: -20,
		// maxDAte: "",
		onSelect: function onSelect(selectedDate) {
			var getDate = $(this).datepicker('getDate');
			var newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut").datepicker("setDate", newDate);
			$("#CheckOut").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn").datepicker("option", "maxDate", selectedDate);
		}
	});

	$("#start_date, #end_date, #arrival_date, #departure_date, #alt_arrival_date, #alt_departure_date, #decision_date, #proposed_date, #date_donation_needed").datepicker({
		changeMonth: true,
		numberOfMonths: 2,
		dateFormat: 'mm/dd/yy'
	});

	// 	blogs
	$('.read-more').click(function (explore) {
		$(this).closest(".blog-post").find('div.more-content').slideToggle();
		var text = $(this).text();
		$(this).text(text == "Show Less -" ? "Read More +" : "Show Less -");
	});

	// Map: Return to previous page button. Change body id to match map template's name.
	//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	$(".videos-lightbox").on('click', function (event) {
		event.preventDefault();
		$.fancybox({
			'type': 'iframe',
			// hide the related video suggestions and autoplay the video
			'href': this.href.replace(new RegExp('watch\\?v=', 'i'), 'embed/') + '?rel=0&autoplay=1',
			'overlayShow': true,
			'centerOnScroll': true,
			'speedIn': 100,
			'speedOut': 50,
			'allowfullscreen': true,
			'width': '80%',
			'height': '80%',
			'autosize': false,
			'iframe': {
				preload: false
			}
		});
	});

	$(".fancybox").fancybox({
		openEffect: 'none',
		closeEffect: 'none',
		iframe: {
			preload: false
		}
	});

	$('.map-home .pins .pin').on('click', function () {

		$('.map-home .pins .pin').removeClass("active");
		$(this).addClass("active");

		var markertsPin = $(this).attr("title");

		$('.map-home .info-posts-attractions .post-map').each(function () {

			$('.map-home .info-posts-attractions .post-map').removeClass("pin-open");
			var popupOpen = $(this).addClass("active");

			var popClass = $(this).attr("id");

			if (markertsPin == popClass) {
				$('.map-home .post-map').fadeOut();
				$(popupOpen).fadeIn();
			}
		});
	});

	// 	Experience section
	$('#upcoming-events').find('.section-title').click(function () {
		if ($(this).hasClass('open')) {
			$(this).removeClass('open');
		} else {
			$('.section-title').removeClass('open');
			$(this).addClass('open');
		}
		$(this).next().slideToggle('fast');
		$(".content-upcoming-events").not($(this).next()).slideUp('fast');
	});

	$('.section-title').click(function () {

		$('html, body').animate({
			scrollTop: $(this).offset().top - 400
		}, 500);
	});

	// Video derby page
	$('#video-derby').click(function () {
		this.paused ? this.play() : this.pause();
	});
	//    $('#video-derby').hover(function toggleControls() {
	//     if (this.hasAttribute("controls")) {
	//         this.removeAttribute("controls")
	//     } else {
	//         this.setAttribute("controls", "controls")
	//     }
	// });

});

$(window).on('load', function () {
	$(".more-content a.btn").parent("p").css({
		"display": "inline-block",
		"margin": "10px 10px"
	});

	$("a.big-btn").parent("p").css({
		"display": "block",
		"margin": "10px 10px"
	});

	//Slick Slider
	$('.slide-reasons-info, .slide-reasons-img').slick();
	$('.sym-slides').slick();
	$('.sym-slides-home').slick({ "arrows": false, "dots": true, "autoplay": true, "autoplaySpeed": 4000, "speed": 500, "fade": true, "accessibility": false });

	$('.slider__center').slick({
		centerMode: true,
		centerPadding: '0',
		slidesToShow: 3,
		infinite: true,
		arrows: true,
		accessibility: true
	});

	$(".dots-box ul li button").each(function () {

		var dotsNumber = $(this).text();

		if ($(dotsNumber).length < 2) {
			$(this).html(0 + dotsNumber);
		}
	});
});

/* Careers Form */

var buttonis = document.querySelectorAll('.additional-btn');
for (var i = 0; i < buttonis.length; i++) {
	buttonis[i].addEventListener('click', function (event) {
		event.preventDefault();
		var nextForm = this.parentNode.nextElementSibling;
		console.log(nextForm);
		nextForm.classList.add('active');
		var radio = nextForm.querySelector('input[type=radio]');
		$(radio).attr("checked", "checked");
	});
}